import React, {useEffect, useState} from 'react';
import {Link, matchPath, Outlet, useLocation, useParams} from 'react-router-dom';
import {Menu} from 'antd';
import _ from 'lodash';

import AppLayout from '../AppLayout';
import AppLayoutHeader from '../AppLayout/AppLayoutHeader';
import AppLayoutHeaderMenu from './AppLayoutHeaderMenu';
import menus from '@/app/RouteConfig/menu';
import {useMenuService} from '../menuService';

function DefaultAppLayoutWrapper() {
    const location = useLocation();
    const params = useParams();
    console.log('DefaultAppLayout location', location, params);
    const [selMenuKey, setSelMenuKey] = useState(null);
    console.log('====DefaultAppLayout selMenuKey', selMenuKey);

    const match = Object.keys(menus)
        .map(key => {
            // console.log('menus[key]?.path', menus[key]?.path);
            const pathMatch = matchPath(menus[key]?.path + '/*', location.pathname);
            return pathMatch && key;
        })
        .filter(Boolean)
        .find(key => !!key);
    console.log('DefaultAppLayout match', match);

    const parentPath = menus[match]?.path ? '/' + menus[match]?.path : '';

    const sideMenus = useMenuService(menus, match);
    const hasMenu = !_.isEmpty(sideMenus);

    // console.log('sideMenus', sideMenus);

    function getPath(path, routeParams) {
        let routePath = `${parentPath}/${path}`;
        if (_.isEmpty(routeParams)) {
            return routePath;
        }
        Object.keys(routeParams).forEach(key => {
            routePath = routePath.replaceAll(`:${key}`, routeParams[key]);
        });
        // console.log('routePath', routePath);
        return routePath;
    }

    // console.log('===selMenuKey', selMenuKey);
    useEffect(() => {
        console.log('----default layout useEffect....');
        if (!hasMenu) {
            return;
        }

        if (_.isEmpty(selMenuKey)) {
            const firstMenu = sideMenus.find(item => !!item.label);
            setSelMenuKey(firstMenu?.path);
            // setSelMenuKey(getPath(firstMenu?.path, params));
        }

        // 初始进入或刷新页面时预先判断下需要高亮哪个菜单
        // AdminRouteConfig 需要去掉收尾两个配置项
        sideMenus.forEach(({label, path}) => {
            if (!label) {
                return;
            }

            // console.log(
            //     '++++++matchPath path, location.pathname',
            //     getPath(path),
            //     location.pathname
            // );
            const m = matchPath(getPath(path), location.pathname);
            // const m = matchPath(location.pathname, getPath(path, params));
            // console.log('default m', m);
            if (m) {
                setSelMenuKey(m?.pattern?.path);
            }
        });

        // 只在 pathname 变化的时候触发
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasMenu, location.pathname, params, sideMenus]);

    const defaultOpenKeys = sideMenus
        .filter(({children, hasSubMenu}) => hasSubMenu && children && children.length > 0)
        .map(({path}) => path);
    // console.log('defaultOpenKeys', defaultOpenKeys);
    const sider = hasMenu && (
        <Menu selectedKeys={[selMenuKey]} mode="inline" defaultOpenKeys={defaultOpenKeys}>
            {sideMenus.map(({label, path, icon, hasSubMenu, children}) => {
                // console.log('sideMenus', path);
                if (!label) return null;

                if (hasSubMenu && !_.isEmpty(children)) {
                    return (
                        <Menu.SubMenu key={path} icon={icon} title={label}>
                            {children.map(item => {
                                const to = getPath(path + '/' + item.path, params);
                                // console.log(to);
                                return (
                                    <Menu.Item key={item.path} icon={item.icon}>
                                        <Link to={to}>{item.label}</Link>
                                    </Menu.Item>
                                );
                            })}
                        </Menu.SubMenu>
                    );
                }

                const to = getPath(path, params);
                return (
                    <Menu.Item key={getPath(path)} icon={icon}>
                        <Link to={to}>{label}</Link>
                    </Menu.Item>
                );
            })}
        </Menu>
    );

    return (
        <AppLayout
            header={
                <AppLayoutHeader>
                    <AppLayoutHeaderMenu />
                </AppLayoutHeader>
            }
            sider={sider}
        >
            <Outlet />
        </AppLayout>
    );
}

export default DefaultAppLayoutWrapper;
